import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const MyInviteCode = React.lazy(() => import('../page/MyInviteCode'));

const routes: AppRouteType[] = [
  {
    path: slugs.myInviteCode,
    component: MyInviteCode,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
